module.exports = {
    locales: ['en', 'da'],
    defaultLocale: 'da',
    pages: {
        '*': ['common'],
        '/': ['home', 'opening-hours'],
        '/compensation': ['compensation'],
        '/arrivals': ['arrivals'],
        '/departures': ['departures'],
        '/passport-control': ['passport-control'],
        '/trains': ['trains'],
        '/when-to-arrive': ['when-to-arrive'],
        '/fast-track': ['fast-track'],
        '/cph-to-copenhagen': ['cph-to-copenhagen'],
        '/cph-to-malmo': ['cph-to-malmo'],
        '/security-opening-hours': ['opening-hours'],
        '/faq': ['faq'],
        '/widget': ['widget'],
        '/embed': ['embed'],
        '/travel-times': ['travel-times'],
        '/travel-times/[day]': ['travel-times'],
        '/best-time-to-arrive': ['best-time-to-arrive'],
        '/best-time-to-arrive/[hour]': ['best-time-to-arrive'],
        '/security-wait': ['security-wait'],
        '/security-wait/[month]': ['security-wait']
    },
    namespace: 'common'
};
